class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.closeButtons = this.querySelectorAll(".js-button-close");
    this.closeButtons.forEach(button => {
      button.addEventListener("click", this.onDismiss.bind(this));
    });
  }

  init() {
    this.delay = Number(this.dataset.delay) * 1000;
    this.dismissDays = Number(this.dataset.dismissDays || 30);
    this.subscribeDays = Number(this.dataset.subscribeDays || 365);
    this.scrollThreshold = Number(this.dataset.scrollThreshold || 35) / 100;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");

    this.delayElapsed = false;
    this.scrollThresholdReached = false;
    this.hasScheduledPopup = false;
    this.hasShownPopup = false;

    this.handleEngagementProgress = this.handleEngagementProgress.bind(this);

    if (this.form?.querySelector('[data-newsletter-success="true"]')) {
      setCookie("newsletter-subscribed", "true", this.subscribeDays);
      this.subscribed = "true";
    }
  }

  onDismiss(event) {
    event.preventDefault();
    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
      this.show();
      }
      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.startPopupSequence();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          observer.disconnect();
          this.startPopupSequence();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  startPopupSequence() {
    if (this.closed === "true" || this.subscribed === "true") return;

    this.startEngagementTracking();
    this.showPopupWithDelay();
  }

  startEngagementTracking() {
    window.addEventListener("scroll", this.handleEngagementProgress, { passive: true });
    window.addEventListener("resize", this.handleEngagementProgress);
    this.handleEngagementProgress();
  }

  stopEngagementTracking() {
    window.removeEventListener("scroll", this.handleEngagementProgress);
    window.removeEventListener("resize", this.handleEngagementProgress);
  }

  handleEngagementProgress() {
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;

    if (maxScroll <= 0) {
      this.scrollThresholdReached = true;
    } else {
      this.scrollThresholdReached = window.scrollY / maxScroll >= this.scrollThreshold;
    }

    if (this.scrollThresholdReached) {
      this.stopEngagementTracking();
      this.maybeShowPopup();
    }
  }

  showPopupWithDelay() {
    if (this.hasScheduledPopup) return;

    this.hasScheduledPopup = true;

    setTimeout(() => {
      this.delayElapsed = true;
      this.maybeShowPopup();
    }, this.delay);
  }

  maybeShowPopup() {
    if (this.hasShownPopup || !this.delayElapsed || !this.scrollThresholdReached) return;
    if (this.closed === "true" || this.subscribed === "true") return;

    this.hasShownPopup = true;
    this.show();
  }

  hide() {
    const shouldPersistDismissal = this.hasAttribute("open") && !Shopify.designMode;

    if (shouldPersistDismissal) {
      setCookie("newsletter-closed", "true", this.dismissDays);
      this.closed = "true";
    }

    this.stopEngagementTracking();
    super.hide();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);
